import { INVALID_VALIDATOR } from 'constants/errors';
import { BaseCustomValidator } from '../types';

const modelBaseValidator: BaseCustomValidator<any> = (validateModel) => (
  value,
  options,
  key,
  attributes,
  globalOptions
) => {
  const { validator } = options;

  if (!validator) { return INVALID_VALIDATOR; }

  const errors = validateModel(value, validator, { ...globalOptions, ...options });
  if (errors !== true) { return errors; }

  return null;
};

export default modelBaseValidator;
